<template>
  <div class="my" :class="$store.state.user.isNested && 'nestedHeader'">
    <!--    <div class="header">榮耀貸</div>-->
    <!--    <div class="userInfo">-->
    <!--      <div class="pic" @click="handleHeaderPic">-->
    <!--        <img src="../../assets/my/avatar2@2x.png" />-->
    <!--      </div>-->
    <!--      <div class="goLogin" v-if="phone">-->
    <!--        {{ phone }}-->
    <!--      </div>-->
    <!--      <div class="goLogin" v-else @click="$router.push('/login')">-->
    <!--        {{ l.my_name_not_login }}>>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="header_bgc_box">
      <div class="header_product">榮耀貸</div>
      <div class="header_good_record">{{ l.my_good_record }}</div>
    </div>
    <!--    <div class="poppup_main">-->
    <!--      <div class="cell_item" @click.stop="$router.push('/personalData')">-->
    <!--        <div class="cell_left">-->
    <!--          <img-->
    <!--              class="cell_left_img"-->
    <!--              src="@/assets/my/gerenziliao@2x.png"-->
    <!--              alt=""-->
    <!--          />-->
    <!--          <div class="cell_left_text">{{ l.my_cell_list_info }}</div>-->
    <!--        </div>-->
    <!--        <img class="cell_right_img" src="@/assets/right@2x.png" alt="" />-->
    <!--      </div>-->
    <!--      <div class="cell_item" @click.stop="showPopup = true">-->
    <!--        <div class="cell_left">-->
    <!--          <img-->
    <!--              class="cell_left_img"-->
    <!--              src="@/assets/my/wodekefu@2x.png"-->
    <!--              alt=""-->
    <!--          />-->
    <!--          <div class="cell_left_text">{{ l.my_cell_list_customer }}</div>-->
    <!--        </div>-->
    <!--        <img class="cell_right_img" src="@/assets/right@2x.png" alt="" />-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="poppup">
      <div class="cell_list">
        <div class="cell_item" @click.stop="$router.push('/personalData')">
          <div class="cell_left">
            <img
                class="cell_left_img"
                src="@/assets/my/gerenziliao@2x.png"
                alt=""
            />
            <div class="cell_left_text">{{ l.my_cell_list_info }}</div>
          </div>
          <img class="cell_right_img" src="@/assets/right@2x.png" alt=""/>
        </div>
        <div class="cell_item" @click.stop="$router.push('/contactUs')">
          <div class="cell_left">
            <img
                class="cell_left_img"
                src="@/assets/my/wodekefu@2x.png"
                alt=""
            />
            <div class="cell_left_text">{{ l.my_cell_list_customer }}</div>
          </div>
          <img class="cell_right_img" src="@/assets/right@2x.png" alt=""/>
        </div>
<!--        <div class="cell_item" @click.stop="$router.push('/help')">-->
<!--          <div class="cell_left">-->
<!--            <img class="cell_left_img" src="@/assets/my/help@2x.png" alt=""/>-->
<!--            <div class="cell_left_text">{{ l.my_cell_list_help }}</div>-->
<!--          </div>-->
<!--          <img class="cell_right_img" src="@/assets/right@2x.png" alt=""/>-->
<!--        </div>-->
<!--        <div class="cell_item" @click.stop="$router.push('/bankCard')">-->
<!--          <div class="cell_left">-->
<!--            <img class="cell_left_img" src="@/assets/my/card@2x.png" alt=""/>-->
<!--            <div class="cell_left_text">{{ l.account_info }}</div>-->
<!--          </div>-->
<!--          <img class="cell_right_img" src="@/assets/right@2x.png" alt=""/>-->
<!--        </div>-->
        <div class="cell_item" @click.stop="showAuditBox(0)">
          <div class="cell_left">
            <img class="cell_left_img" src="@/assets/my/privay@2x.png" alt=""/>
            <div class="cell_left_text">{{ l.my_cell_list_privacy }}</div>
          </div>
          <img class="cell_right_img" src="@/assets/right@2x.png" alt=""/>
        </div>
        <div v-if="$store.state.user.userInfo.user_id" class="cell_item" @click="show = true">
          <div class="cell_left">
            <img class="cell_left_img" src="@/assets/my/shezhi@2x.png" alt=""/>
            <div class="cell_left_text">{{ l.my_setting_logout_btn }}</div>
          </div>
          <img class="cell_right_img" src="@/assets/right@2x.png" alt=""/>
        </div>
        <div v-else class="cell_item">
          <div class="cell_left">
            <div class="cell_left_img"></div>
            <div class="cell_left_text"></div>
          </div>
          <div class="cell_right_img"></div>
        </div>
      </div>
    </div>

    <van-dialog
        class="dialog_go_page"
        v-model="show"
        :showConfirmButton="false"
    >
      <div class="dialog_go_page_content_box">
        <div @click="show = false" class="dialog_go_page_cancel"></div>
        <div class="dialog_go_page_title"><img src="@/assets/home/tips.png" alt=""> {{ l.my_setting_logout_title }}</div>
        <div class="dialog_go_page_content">{{ l.my_setting_logout_msg }}</div>
        <div @click="logoutBtn" class="dialog_go_page_btn">
          {{ l.login_ok }}
        </div>
      </div>
    </van-dialog>

    <Popup
        :close-on-click-overlay="false"
        position="center"
        round
        v-model="showPopup"
    >
      <div class="myCustomerBox">
        <div class="myCustomer" v-if="conf">
          <div
              v-if="conf.hot_tel"
              class="custItem"
              @click="openPhone(conf.hot_tel)"
          >
            {{ l.my_setting_phone_cust }}: {{ conf.hot_tel }}
          </div>
          <div
              v-if="conf.zalo_phone"
              class="custItem"
              @click="linkTo('https://zalo.me/' + conf.zalo_phone)"
          >
            {{ l.my_setting_zalo_cust }}{{ conf.zalo_phone | isWebsite }}
          </div>
          <div
              v-if="conf.faceBook_phone"
              class="custItem"
              @click="linkTo(conf.faceBook_phone)"
          >
            {{
              l.my_setting_facebook_cust
            }}{{ conf.faceBook_phone | isWebsite }}
          </div>
        </div>
      </div>
      <div class="custClose" @click="showPopup = false">
        <!-- {{ l.my_setting_close }} -->
      </div>
    </Popup>
    <AuditBox
        :boxIndex="textIndex"
        :show="isShowAuditBox"
        @closePopup="closeAuditBoxPopup"
    />
  </div>
</template>

<script>
import {logout, config} from "../../services/user";
import {Dialog, Toast, Popup} from "vant";
import AuditBox from "@/components/auditBox";
import l from "../../locales";

export default {
  name: "my",
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Popup,
    AuditBox,
  },
  data() {
    return {
      phone: null,
      l: {...l.my, ...l.login, ...l.repayMethods,...l.router},
      show: false,
      showPopup: false,
      conf: undefined,
      textIndex: 0,
      isShowAuditBox: false,
    };
  },
  filters: {
    isWebsite(val) {
      // return /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(
      //   val
      // )
      //   ? ""
      //   : ": " + val;
      return ": " + val;
    },
  },
  methods: {
    showAuditBox(index) {
      this.textIndex = index;
      this.isShowAuditBox = true;
    },
    closeAuditBoxPopup() {
      this.isShowAuditBox = false;
    },
    openPhone(str) {
      if (process.env.VUE_APP_GENRE === "nested") {
        this.$tools.androidMethod(
            "callService",
            {
              phone: str,
            },
            ""
        );
      } else {
        window.location.href = "tel:" + str;
      }
    },
    linkTo(str) {
      if (
          /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(
              str
          )
      ) {
        if (process.env.VUE_APP_GENRE === "nested") {
          this.$tools.androidMethod(
              "openWeb",
              {
                openUri: str,
              },
              ""
          );
        } else {
          window.location.href = str;
        }
      } else {
        const input = document.createElement("input");
        input.setAttribute("value", str);
        document.body.appendChild(input);
        input.select();
        document.execCommand("Copy");
        document.body.removeChild(input);
        Toast(this.l.bank_copy_suc);
      }
    },
    logoutBtn() {
      console.log("退出登录");
      logout().then((res) => {
        console.log(res);
        if (res.code == 200) {
          Toast.success(this.l.my_setting_logout_toast);
          this.$store.commit("LOGOUT_MOVE_USER_INFO");

          if (process.env.VUE_APP_GENRE === "nested") {
            this.$tools.androidMethod("signOut", {}, "");
          } else {
            this.$router.push("login");
          }
        }
      });
    },
    handleSettingClick() {
      this.$router.push("/setting");
    },
    handleHeaderPic() {
      if (!this.$store.state.user.userInfo) {
        this.$router.push("/login");
      }
    },
    async init() {
      let conf = JSON.parse(localStorage.getItem("config") || "{}");
      if (!conf) {
        let res = await config();
        conf = res.result;
      }
      this.conf = conf;
      console.log("conf", conf);
    },
  },
  activated() {
    this.init();
    if (this.$store.state.user.userInfo != null && this.$store.state.user.userInfo.user_id) {
      this.phone = this.$store.state.user.userInfo.phone;
    }
  },
};
</script>

<style lang="less" scoped>
.my {
  position: relative;

  width: 100%;
  min-height: 100vh;
  //height: 100%;
  //background: url("../../assets/my/bgc.png") no-repeat;
  //background-size: 100%;

  background: #FFFFFF;
  padding-top: 30px;
  box-sizing: border-box;

}

.header {
  padding-top: 20px;
  box-sizing: border-box;
  text-align: center;

  height: 40px;

  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}

.userInfo {
  display: flex;
  align-items: center;
  margin: 0 20px;
  margin-top: 20px;

  .pic {
    margin-right: 10px;
    border-radius: 50%;

    img {
      width: 70px;
      height: 70px;
    }
  }

  .goLogin {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
}

.header_bgc_box {
  margin: 0 15px;
  width: calc(100% - 30px);
  height: 90px;
  background: url("~@/assets/my/bgc.png") no-repeat;
  background-size: 100% 100%;
  padding: 0 15px;
  padding-top: 20px;
  box-sizing: border-box;

  .header_product {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #0C4B74;
  }

  .header_good_record {
    margin-top: 15px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #6C94AF;
  }
}

.poppup_main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px;
  margin-top: 20px;

  .cell_item {
    width: 160px;
    height: 93px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.66) 0%, rgba(255, 255, 255, 0.86) 100%);
    box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    backdrop-filter: blur(5px);

    .cell_left {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      height: 100%;

      .cell_left_img {
        width: 44px;
        height: 44px;
      }

      .cell_left_text {
        width: 100%;
        height: 20px;
        text-align: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #323940;
      }
    }

    .cell_right_img {
      display: none;
    }

  }
}

.poppup {
  text-align: center;
  box-sizing: border-box;
  padding: 0 20px;
  //margin: 0 20px;
  margin-top: 40px;

  //height: 90vh;

  .cell_list {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;

    .cell_item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      width: 50%;
      box-sizing: border-box;
      margin-bottom: 50px;

      .cell_left {
        position: relative;
        align-items: center;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .cell_left_img {
          width: 48px;
          height: 48px;
          //margin-right: 10px;
        }

        .cell_left_text {
          margin-top: 6px;
          width: 100%;
          height: 20px;
          //margin-top: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #28435B;

        }
      }

      .cell_right_img {
        width: 22px;
        height: 22px;
        display: none;
      }

      &:first-child {
        background: none;
      }
    }

    // .cell_item:first-child {
    //   margin-top: 0;
    // }
  }
}

/deep/ .van-overlay {
  background: rgba(101, 101, 101, 0.2);
  backdrop-filter: blur(3px);
}

.dialog_go_page {
  top: auto;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;

  height: 254px;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;

  box-sizing: border-box;
  overflow: visible;

  .dialog_go_page_content_box {
    position: relative;
    padding-top: 65px;

    .dialog_go_page_title {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #28435B;
      img{
        width: 20px;
        height: 20px;
        margin-right: 5px;
      }
    }

    .dialog_go_page_content {
      margin-top: 15px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #FF4D4D;

    }

    .dialog_go_page_btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 52px;
      margin-top: 50px;

      height: 48px;
      background: #B8D6E2;

      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #00819F;

      border-radius: 24px;
    }
  }

  .dialog_go_page_cancel {
    position: absolute;
    top: 20px;
    right: 20px;
    background: url(../../assets/my/close@2x.png) no-repeat;
    background-size: 100% 100%;
    width: 14px;
    height: 14px;
  }

  /deep/ .van-dialog__header {
    padding-top: 18px;
    padding-bottom: 10px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232425;

    border-bottom: 1px solid #d8d8d8;
  }

  /deep/ .van-dialog__footer {
    position: absolute;
    bottom: 21px;
  }

  /deep/ .van-dialog__cancel {
    position: absolute;
    top: 20px;
    right: 20px;
    background: url(../../assets/my/close@2x.png) no-repeat;
    background-size: 100% 100%;
    width: 28px;
    height: 28px;
  }

  /deep/ .van-dialog__confirm {
    margin-right: 22px;
    width: 114px;
    height: 38px;
    background: #d8d8d8 linear-gradient(90deg, #ebcfa4 0%, #dcb98f 47%, #cfa77d 100%);
    border-radius: 19px;

    .van-button__text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.myCustomerBox {
  position: relative;
}

/deep/ .van-popup {
  overflow: visible;
}

.custClose {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translate(-50%, 100%);
  background: url(../../assets/my/close@2x.png) no-repeat;
  background-size: 100% 100%;
  width: 26px;
  height: 26px;
}

.myCustomer {
  position: relative;
  width: 325px;

  padding: 0 20px;
  padding-top: 20px;
  box-sizing: border-box;

  background: #ffffff;
  border-radius: 18px;

  .custItem {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-bottom: 20px;
    box-sizing: border-box;

    // height: 42px;
    padding: 4px 8px;

    background: rgba(69, 161, 255, 0.1);
    border-radius: 21px;
    border: 1px solid #00819F;

    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #00819F;
  }
}
</style>
